import { RentvineConnectForm } from './RentvineConnectForm'
import type { VendorConnectorProps } from './types'

export function RentvineConnector({ onConnected }: VendorConnectorProps) {
  return <RentvineConnectForm onConnected={() => onConnected?.()} />
}
